export const statusServicosDiretivo: {name: string, descricao: string}[] = [
    { name: "NOVO", descricao: "Novo" },
    { name: "CONTRATADO", descricao: "Contratado" },
    { name: "AGUARDANDO_AVALIACAO", descricao: "Aguardando avaliação" },
    { name: "FINALIZADO", descricao: "Finalizado" },
    { name: "PENDENTE_PAGAMENTO", descricao: "Pendente Pagamento" },
    { name: "DESMARCADO", descricao: "Desmarcado" },
    { name: "CANCELADO", descricao: "Cancelado" },
    { name: "ORCAMENTO_SOLICITADO", descricao: "Orçamento Solicitado" },
    { name: "EM_ORCAMENTACAO", descricao: "Em Orçamentação" },
    { name: "RECUSADO_CENTRAL", descricao: "Solicitação Recusada" },
    { name: "RECUSADO_CLIENTE", descricao: "Orçamento Recusado" },
    { name: "ORCAMENTO_FINALIZADO", descricao: "Orçamento finalizado" },
    { name: "EM_APROVACAO_VALOR_ADICIONAL", descricao: "Pendente aprovação do valor adicional" },
    { name: "VALOR_ADICIONAL_RECUSADO", descricao: "Valor adicional recusado" },
    { name: "CRIADO", descricao: "Criado" },
    { name: "PRECIFICADO", descricao: "Precificado" },
    { name: "ABERTO", descricao: "Aberto" },
    { name: "EM_EXECUCAO", descricao: "Em execução" },
    { name: "PENDENTE_APROVACAO", descricao: "Pendente aprovação" },
    { name: "PAGO", descricao: "Pago" },
];